import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Spin } from 'antd';

import ConfirmedRefillLists from './ConfirmedRefillLists';
import { SET_REFILLS } from '../../ActionTypes/ActionTypes';

class ConfirmedRefills extends Component {
    state = {
        loading: false,
    }

    componentDidMount = () => {
        const { setRefills } = this.props;

        this.setState({ loading: true });
        axios({
            method: 'get',
            url: '/carefills/carefills_by_status.json?status=Confirmed',
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                setRefills(response.data.carefills);
                this.forceUpdate();
                this.setState({
                    loading: false,
                });
            });
    }


    render() {
        const { loading } = this.state;
        return (
            <div>
                {
                    loading
                        ? <Spin />
                        : <ConfirmedRefillLists />
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    refillsList: state.RefillState.refillsList,
});

const mapDispatchToProps = dispatch => ({
    setRefills: data => dispatch({ type: SET_REFILLS, payload: { data } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmedRefills);



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/ConfirmedRefills.js